/**
 * Product Variant Navigation - Section Rendering API
 * Allows navigating between product variants without page reload
 */

const event = new Event("section-render-api", { bubbles: true });

function initializeSizeValidation() {
  if (typeof jQuery === 'undefined') return;
  
  const $ = jQuery;
  
  if ($('fieldset').length > 1) {
    var $selector = $('fieldset')[0];
    $('fieldset[data-option-name="width"]').find('.product-form__controls-group').find('input[type="radio"]:not(.disabled):first').prop("checked", true).trigger('click');
    $('.product-form__submit[name="add"]').addClass('size_disabled');
    
    // Update button text when size_disabled class is present
    updateButtonText();

    $('.product-form__controls-group[data-option-name="size"]').find('[type="radio"]').off('click').on('click', function(){
      $(this).closest('.product__info-container').find('.product-form').find('button[name="add"]').removeClass('size_disabled');
      // Hide the error message
      $('.product-form__error-message-wrapper').attr('hidden', true);
      $('.product-form__error-message').text('');
      updateButtonText();
    });

    $('.size_disabled').off('click').on('click', function(e) {
      if ($(this).hasClass('size_disabled')) {
        console.log('clicked');
        e.preventDefault();
        var $size_option = $(this).closest('.product__info-wrapper').find('.product-form__input--radios').find('.product-form__controls-group[data-option-name="size"]').find('[type="radio"]').is(':checked');
        if (!$size_option) {
          // Show error message using product-form__error-message
          $('.product-form__error-message').text('Please select a size');
          $('.product-form__error-message-wrapper').removeAttr('hidden');
        } else {
          $(this).removeClass('size_disabled');
          $('.product-form__error-message-wrapper').attr('hidden', true);
          $('.product-form__error-message').text('');
        }
        return false;
      } else {
        return true;
      }
    });

    function checkWidth() {
      var $selWidth = $('#SingleOptionSelector-0').find('input[type="radio"]:checked').val();
      $('select[name="currid"]').find('option').each(function() {
        var $this = $(this);
        var w = $this.text().split(" / ")[0];
        var s = ($this.text().split(" / ")[1]).split("--")[0];
        var a = ($this.text().split(" / ")[1]).split("--")[1];
        var $selWidth = $('fieldset[data-option-name="width"]').find('.product-form__controls-group').find('input[type="radio"]:checked').val();
        
        console.log('currID=>', $this.text());
        console.log('w=>', w);
        console.log('s=>', s);
        console.log('a=>', a);
        console.log('$selWidth=>', $selWidth);
        
        if (w == $selWidth) {
          if (a == 'avail') {
            $('.product-form__input--radios[data-option-name="size"] > .product-form__controls-group > input[type="radio"][value="' + s + '"]').removeClass('disabled');
          }
        }
      });
    }
    checkWidth();

    $('.product-form__controls-group[data-option-name="width"]').find('[type="radio"]').off('click').on('click', function(){
      $('.product-form__controls-group[data-option-name="size"] input[type="radio"]').addClass('disabled');
      checkWidth();

      var $currSize = $('.product-form__controls-group[data-option-name="size"] input[type="radio"]:checked').val();
      $('.product-form__controls-group[data-option-name="size"] input[type="radio"][value="' + $currSize + '"]').removeAttr('checked');
      $('.product-form__controls-group[data-option-name="size"] input[type="radio"][value="' + $currSize + '"]').prop('checked', false);
      $('button[name="add"]').removeAttr('disabled').addClass('size_disabled');
      updateButtonText();
    });
  }
}

function updateButtonText() {
  if (typeof jQuery === 'undefined') return;
  
  const $ = jQuery;
  const button = $('button[name="add"]');
  const defaultText = button.find('.button-text-default');
  const selectSizeText = button.find('.button-text-select-size');
  
  if (button.hasClass('size_disabled')) {
    defaultText.hide();
    selectSizeText.show();
  } else {
    defaultText.show();
    selectSizeText.hide();
  }
}

function initializeAccordions() {
  if (typeof jQuery === 'undefined') return;
  
  const $ = jQuery;
  
  // Remove any existing click handlers to prevent duplicates
  $(".product-about__accordion-title").off('click');
  
  // Re-attach accordion click handlers
  $(".product-about__accordion-title").on('click', function () {
    if (!$(this).hasClass("active")) {
      $(".product-about__accordion-title.active").removeClass("active");
      $(this).addClass("active");
      $(".product-about__accordion-description").stop().slideUp(300);
      $(this)
        .siblings(".product-about__accordion-description")
        .stop()
        .slideDown(300);
    } else {
      $(this).removeClass("active");
      $(this).siblings(".product-about__accordion-description").stop().slideUp(300);
    }
  });
}

function initializeCopyButtons() {
  // Reinitialize copy button listeners
  const copyLinks = document.querySelectorAll('.copy-btn, .copy-link-btn');
  
  copyLinks.forEach(copyLink => {
    // Remove existing listeners to prevent duplicates
    const newCopyLink = copyLink.cloneNode(true);
    copyLink.parentNode.replaceChild(newCopyLink, copyLink);
    
    // Add the click listener
    newCopyLink.addEventListener('click', function(evt) {
      evt.preventDefault();
      const button = evt.currentTarget;
      
      navigator.clipboard.writeText(window.location.href).then(() => {
        const originalHTML = button.innerHTML;
        const originalLabel = button.getAttribute('aria-label');
        
        const checkIcon = `
          <svg width="21" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 100%; height: 100%;">
            <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `;
        
        button.innerHTML = checkIcon;
        button.setAttribute('aria-label', 'Link copied!');
        button.style.color = '#021769';
        
        setTimeout(() => {
          button.innerHTML = originalHTML;
          if (originalLabel) {
            button.setAttribute('aria-label', originalLabel);
          }
          button.style.color = '';
        }, 2000);
      }).catch(err => {
        console.error('Failed to copy link:', err);
      });
    });
  });
}

function attachProductClickListener() {
  const products = document.querySelector(".group-products");
  if (products) {
    products.addEventListener("click", handleClick);
    document.dispatchEvent(event);
  }
  
  // Initialize size validation on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSizeValidation);
  } else {
    initializeSizeValidation();
  }
}

function handleClick(event) {
  const anchor = event.target.closest("a[data-url]");
  if (!anchor) return;
  event.preventDefault();

  const url = anchor.getAttribute("data-url");
  const section = document.querySelector('[id^="MainProduct-"]');
  
  if (!section) {
    console.error("No MainProduct element found");
    window.location.href = url;
    return;
  }

  // Show loading state
  section.style.opacity = "0.6";
  section.style.pointerEvents = "none";
  
  fetch(url)
    .then(response => response.text())
    .then(resText => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(resText, "text/html");
      const newMainContent = doc.querySelector('[id^="MainProduct-"]');
      
      if (newMainContent) {
        // Replace the content
        section.innerHTML = newMainContent.innerHTML;
        
        // Update the URL without reload
        history.pushState(null, '', url);
        
        // Update the page title
        const newTitle = doc.querySelector('title');
        if (newTitle) {
          document.title = newTitle.innerText;
        }
        
        // Reset opacity
        section.style.opacity = "1";
        section.style.pointerEvents = "auto";
        
        // Reattach the click listener after updating the content
        attachProductClickListener();
        
        // Reinitialize size validation
        initializeSizeValidation();
        
        // Reinitialize accordions (description, reviews, etc.)
        initializeAccordions();
        
        // Reinitialize copy buttons
        initializeCopyButtons();
        
        // Reinitialize any Shopify scripts that might be needed
        if (window.Shopify && window.Shopify.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }
        
        // Dispatch event for other scripts that might need to reinitialize
        document.dispatchEvent(new CustomEvent('product-variant-changed', { 
          detail: { url: url } 
        }));
        
        // Scroll to top of product section
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        
      } else {
        console.error("No MainProduct element found in the fetched HTML.");
        window.location.href = url;
      }
    })
    .catch(error => {
      console.error("Error fetching new content:", error);
      // Fallback: Navigate to the URL if the fetch fails
      window.location.href = url;
    });
}

// Initial attachment when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', attachProductClickListener);
} else {
  attachProductClickListener();
}

